import { Avatar, Box, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography } from "@mui/material";
import { SearchListItemLink } from "./SearchListItemLink";

export const ClaimantListItem = (props: any) => {
  const { data, onClick } = props;
  const { content } = data;

  if (!content) {
    return null;
  }

  const displayName = content.claimant_name || content.label || "Unknown Claimant";
  const firstLetter = displayName?.charAt(0)?.toUpperCase() || "?";

  return (
    <ListItem sx={{ px: 0 }}>
      <ListItemButton data={data} component={SearchListItemLink} onClick={onClick}>
        <ListItemAvatar>
          <Avatar>{firstLetter}</Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={displayName}
          secondary={
            <Box>
              {content.claimant_relationship && (
                <Typography variant="caption" color="text.secondary">
                  {content.claimant_relationship.charAt(0).toUpperCase() + content.claimant_relationship.slice(1)}
                </Typography>
              )}
              {content.aegle_id && (
                <Typography variant="caption" color="text.secondary" display="block">
                  ID: {content.aegle_id}
                </Typography>
              )}
            </Box>
          }
        />
      </ListItemButton>
    </ListItem>
  );
};
